import React, { Component } from "react";

export default class FormsRow extends Component {
  render() {
    const className = this.props.className;
    const style = this.props.style;
    return (
      <div className={`row ${className ? className : ""}`} style={style}>
        {this.props.children}
      </div>
    );
  }
}
